<template>
  <div>
    <v-select
      v-model="formData.duracion_estimada"
      :disabled="disabled"
      :label="$t('Duración estimada')"
      :items="tiposDeDuracionEstimada"
      :rules="[rules.required]"
      required
      item-text="label"
      item-value="value"
      box
      :menu-props="{
        bottom: true,
        'offset-y': true,
      }"
    ></v-select>
    <v-menu
      v-model="showRequestDatePicker"
      :close-on-content-click="false"
      :nudge-right="40"
      lazy
      transition="scale-transition"
      offset-y
      full-width
      min-width="290px"
      :disabled="disabled"
    >
      <template v-slot:activator="{ on }">
        <v-text-field
          ref="date"
          :rules="[rules.required]"
          v-model="formattedDate"
          class="pr-2"
          :label="$t('Fecha fin de llamamiento')"
          readonly
          mask="date"
          v-on="on"
          box
          :disabled="disabled"
        ></v-text-field>
      </template>
      <v-date-picker
        v-model="formData.fecha_fin_llamamiento"
        @input="showRequestDatePicker = false"
        locale="es"
        first-day-of-week="1"
        :reactive="true"
      ></v-date-picker>
    </v-menu>
  </div>
</template>

<script>
const moment = require('moment');
export default {
  components: {},
  props: {
    disabled: {
      type: Boolean,
      default: false,
    },
    value: {
      type: Object,
      default() {
        return {
          duracion_estimada: null,
          fecha_fin_llamamiento: null,
        };
      },
    },
  },
  data() {
    return {
      rules: {
        required: value => !!value || 'Este campo es obligatorio.',
        counter: value => value.length <= 20 || 'Max 20 characters',
        email: value => {
          const pattern = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
          return pattern.test(value) || 'Email inválido';
        },
      },
      showRequestDatePicker: false,
      tiposDeDuracionEstimada: [
        { label: '1 mes', value: '1' },
        { label: '2 meses', value: '2' },
        { label: '3 meses', value: '3' },
        { label: '4 meses', value: '4' },
        { label: '5 meses', value: '5' },
        { label: '6 meses', value: '6' },
        { label: '7 meses', value: '7' },
        { label: '8 meses', value: '8' },
        { label: '9 meses', value: '9' },
        { label: '10 meses', value: '10' },
        { label: '11 meses', value: '11' },
        { label: '12 meses', value: '12' },
      ],
    };
  },
  computed: {
    formData: {
      get() {
        return this.value;
      },
      set(value) {
        this.$emit('input', value);
      },
    },
    formattedDate: {
      get() {
        return this.formData.fecha_fin_llamamiento
          ? moment(this.formData.fecha_fin_llamamiento).format('DD/MM/YYYY')
          : '';
      },
      set(value) {
        this.$emit('input', this.formData);
      },
    },
  },
  mounted() {},
  methods: {},
  watch: {},
};
</script>

<style lang="scss"></style>
